<template>
    <routine-editor ref="editor" :coach-id="coachId" @close="onClose" />
</template>

<script>
import RoutineEditor from "@/components/coach/routines/RoutineEditor";
import { mapState } from "vuex";

export default {
    components: { RoutineEditor },
    data() {
        return {
            fromRoute: null,
        }
    },
    computed: {
        ...mapState(['libraryCoach']),
        coachId(vm = this) {
            return vm.accountType === 'company' ? (vm.libraryCoach?.id || null) : (vm.currentUser?.uid || null)
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => { vm.fromRoute = from })
    },
    mounted() {
        this.$refs.editor.showEdit({ objectID: this.$route.params.uid })
    },
    methods: {
        onClose() {
            const vm = this
            if (vm.fromRoute?.name) {
                vm.$router.push({ name: vm.fromRoute.name, params: vm.fromRoute.params, query: vm.fromRoute.query }).catch(() => { })
            } else {
                vm.$router.push({ name: `${vm.accountType}.library` }).catch(() => { })
            }
        },
    },
}
</script>
